
import { Component, Prop, Vue } from "vue-property-decorator";
import { Logger } from "@/utils/Logger";

@Component
export default class SideMenu extends Vue {
  @Prop() displayMenu!: boolean;
  @Prop() isAdmin!: boolean;

  allerAListeEditeurs(): void {
    this.$router.push({ name: "ListeEditeurs" }).catch(err => {
      Logger.error(err);
    });
  }

  allerAListeEtabs(): void {
    this.$router.push({ name: "ListeEtab" }).catch(err => {
      Logger.error(err);
    });
  }

  allerATableauDeBord(): void {
    this.$router.push({ name: "Home" }).catch(err => {
      Logger.error(err);
    });
  }

  allerAStatitique(): void {
    this.$router.push({ name: "Statistiques" }).catch(err => {
      Logger.error(err);
    });
  }

  allerAHistorique(): void {
    this.$router.push({ name: "Historique" }).catch(err => {
      Logger.error(err);
    });
  }

  allerRecherche(): void {
    this.$router.push({ name: "Recherche" }).catch(err => {
      Logger.error(err);
    });
  }

  allerAListeIPs(): void {
    this.$router.push({ name: "ListeIP" }).catch(err => {
      Logger.error(err);
    });
  }
}
